import React from 'react';
import { Link } from 'react-router-dom';
import logo from '../assets/images/LogoJD-sin fondo.PNG';
import { FaFacebook, FaInstagram, FaTiktok, FaWhatsapp } from 'react-icons/fa';
import { MdEmail } from 'react-icons/md';

const Footer = () => {
  return (
    <footer className="bg-brand-black text-brand-white py-8">
      <div className="container mx-auto px-4">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          <div className="text-center">
            <div className="flex justify-center mb-4">
              <img src={logo} alt="J&D Propiedad Raíz Logo" className="h-24 md:h-32" />
            </div>
            <p className="text-brand-gold/80">
              Tu socio confiable en bienes raíces.
            </p>
            <p className="text-brand-gold/60 text-sm mt-2">
              <strong className="text-brand-gold">Oficina Virtual</strong> - Atención 100% digital
            </p>
          </div>
          <div>
            <h3 className="text-lg font-bold mb-4 text-brand-gold">Enlaces Rápidos</h3>
            <ul className="space-y-2">
              <li><Link to="/properties" className="hover:text-brand-gold transition-colors">Propiedades</Link></li>
              <li><Link to="/nosotros" className="hover:text-brand-gold transition-colors">Nosotros</Link></li>
              <li><Link to="/contacto" className="hover:text-brand-gold transition-colors">Contacto</Link></li>
              <li><a href='https://wa.me/573102390002?text=Hola,%20quiero%20consignar%20mi%20propiedad.' target='_blank' rel="noopener noreferrer" className="hover:text-brand-gold transition-colors">Consigna tu Propiedad</a></li>
            </ul>
          </div>
          <div>
            <h3 className="text-lg font-bold mb-4 text-brand-gold">Contáctanos</h3>
            <div className="space-y-3">
              <div className="flex items-center space-x-3">
                <FaWhatsapp className="text-brand-gold" />
                <div>
                  <a href="https://wa.me/573102390002" target="_blank" rel="noopener noreferrer" className="hover:text-brand-gold transition-colors">
                    +57 310 239 0002
                  </a>
                  <p className="text-xs text-brand-gold/60">WhatsApp</p>
                </div>
              </div>
              <div className="flex items-center space-x-3">
                <MdEmail className="text-brand-gold" />
                <div>
                  <a href="mailto:servicioalcliente@jdpropiedadraiz.co" className="hover:text-brand-gold transition-colors">
                    servicioalcliente@jdpropiedadraiz.co
                  </a>
                  <p className="text-xs text-brand-gold/60">Email</p>
                </div>
              </div>
            </div>
            <div className="flex space-x-4 mt-6">
              <a href="https://www.tiktok.com/@jdpropiedadraiz?_t=ZS-8z9pNchDxgn&_r=1" target="_blank" rel="noopener noreferrer" className="hover:text-brand-gold transition-colors"><FaTiktok size={24} /></a>
              <a href="https://www.instagram.com/jdpropiedadraiz?igsh=MWNzYjd1NzhnMDg2YQ%3D%3D&utm_source=qr" target="_blank" rel="noopener noreferrer" className="hover:text-brand-gold transition-colors"><FaInstagram size={24} /></a>
              <a href="https://www.facebook.com/share/1BWgcE3yYc/?mibextid=wwXIfr" target="_blank" rel="noopener noreferrer" className="hover:text-brand-gold transition-colors"><FaFacebook size={24} /></a>
            </div>
          </div>
        </div>
        <div className="text-center text-brand-gold/70 mt-8 pt-4 border-t border-brand-gold/30">
          <p>&copy; {new Date().getFullYear()} J&D Propiedad Raíz. Todos los derechos reservados.</p>
          <p className="text-sm mt-1">Oficina Virtual - Servicio 100% Digital</p>
          <p className="text-xs mt-2 text-brand-gold/50">
            Desarrollado por <span className="text-brand-gold font-medium"> <a href="https://wa.me/573016948910?text=Hola,%20quiero%20más%20información%20sobre%20sus%20servicios." target="_blank" rel="noopener noreferrer">Andrés Giraldo</a></span>
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
